"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateFilterCohortDays = exports.RetentionChartSettingsJSONModel = exports.ChartType = exports.isDefaultFilterCohortDays = exports.HighchartsSettingsFilterCohortDays = exports.isDefaultFilterPeriod = void 0;
const lodash_1 = __importDefault(require("lodash"));
const defaultFilterPeriod_Day = [1, 7, 30];
const defaultFilterPeriod_Week = [0, 1, 2, 3];
const defaultFilterPeriod_Month = [0, 1];
const isDefaultFilterPeriod = (value, retentionType) => {
    switch (retentionType) {
        case "nDay":
            return lodash_1.default.isEqual(value, defaultFilterPeriod_Day);
        case "nWeek":
            return lodash_1.default.isEqual(value, defaultFilterPeriod_Week);
        case "nMonth":
            return lodash_1.default.isEqual(value, defaultFilterPeriod_Month);
    }
};
exports.isDefaultFilterPeriod = isDefaultFilterPeriod;
var HighchartsSettingsFilterCohortDays;
(function (HighchartsSettingsFilterCohortDays) {
    HighchartsSettingsFilterCohortDays["avg"] = "avg";
    HighchartsSettingsFilterCohortDays["daysShift"] = "daysShift";
})(HighchartsSettingsFilterCohortDays = exports.HighchartsSettingsFilterCohortDays || (exports.HighchartsSettingsFilterCohortDays = {}));
const defaultFilterCohortDays = {
    [HighchartsSettingsFilterCohortDays.avg]: true,
    daysShift: [],
};
const isDefaultFilterCohortDays = (value) => lodash_1.default.isEqual(value, defaultFilterCohortDays);
exports.isDefaultFilterCohortDays = isDefaultFilterCohortDays;
////////////////////////////////////////////////
// ChartType
////////////////////////////////////////////////
var ChartType;
(function (ChartType) {
    ChartType["classic"] = "classic";
    ChartType["overtime"] = "overtime";
})(ChartType = exports.ChartType || (exports.ChartType = {}));
class RetentionChartSettingsJSONModel {
    constructor(serializedState) {
        this.reset = () => {
            this.resetChartType();
            this.resetFilterPeriod_Day();
            this.resetFilterPeriod_Week();
            this.resetFilterPeriod_Month();
            this.resetFilterCohortDays();
        };
        this.overwriteFromSerializedState = (serializedState) => {
            if (serializedState) {
                this.chartType = validateChartType(serializedState.chartType);
                this.filterPeriod_day = validateFilterPeriod(serializedState.filterPeriod_day, defaultFilterPeriod_Day);
                this.filterPeriod_week = validateFilterPeriod(serializedState.filterPeriod_week, defaultFilterPeriod_Week);
                this.filterPeriod_month = validateFilterPeriod(serializedState.filterPeriod_month, defaultFilterPeriod_Month);
                this.filterCohortDays = (0, exports.validateFilterCohortDays)(serializedState.filterCohortDays);
            }
        };
        this.serialize = () => {
            return {
                chartType: this.chartType,
                filterPeriod_day: this.filterPeriod_day,
                filterPeriod_week: this.filterPeriod_week,
                filterPeriod_month: this.filterPeriod_month,
                filterCohortDays: this.filterCohortDays,
            };
        };
        ////////////////////////////////////////////////
        // ChartType
        ////////////////////////////////////////////////
        this.getChartType = () => this.chartType;
        this.setChartType = (value) => this.chartType = validateChartType(value);
        this.resetChartType = () => this.setChartType(undefined);
        ////////////////////////////////////////////////
        // FilterPeriod
        ////////////////////////////////////////////////
        this.getFilterPeriodByRetentionType = (retentionType) => {
            return retentionType === "nDay" ? this.getFilterPeriod_Day() :
                retentionType === "nWeek" ? this.getFilterPeriod_Week() :
                    this.getFilterPeriod_Month();
        };
        this.setFilterPeriodByRetentionType = (value, retentionType) => {
            return retentionType === "nDay" ? this.setFilterPeriod_Day(value) :
                retentionType === "nWeek" ? this.setFilterPeriod_Week(value) :
                    this.setFilterPeriod_Month(value);
        };
        this.getFilterPeriod_Day = () => this.filterPeriod_day;
        this.getFilterPeriod_Week = () => this.filterPeriod_week;
        this.getFilterPeriod_Month = () => this.filterPeriod_month;
        this.setFilterPeriod_Day = (value) => this.filterPeriod_day = validateFilterPeriod(value, defaultFilterPeriod_Day);
        this.setFilterPeriod_Week = (value) => this.filterPeriod_week = validateFilterPeriod(value, defaultFilterPeriod_Week);
        this.setFilterPeriod_Month = (value) => this.filterPeriod_month = validateFilterPeriod(value, defaultFilterPeriod_Month);
        this.resetFilterPeriod_Day = () => this.setFilterPeriod_Day(undefined);
        this.resetFilterPeriod_Week = () => this.setFilterPeriod_Week(undefined);
        this.resetFilterPeriod_Month = () => this.setFilterPeriod_Month(undefined);
        ////////////////////////////////////////////////
        // FilterCohortDays
        ////////////////////////////////////////////////
        this.getFilterCohortDays = () => this.filterCohortDays;
        this.setFilterCohortDays = (value) => {
            this.filterCohortDays = (0, exports.validateFilterCohortDays)(value);
        };
        this.resetFilterCohortDays = () => this.setFilterCohortDays(undefined);
        this.reset();
        this.overwriteFromSerializedState(serializedState);
    }
}
exports.RetentionChartSettingsJSONModel = RetentionChartSettingsJSONModel;
RetentionChartSettingsJSONModel.getDefaultModel = () => {
    return new RetentionChartSettingsJSONModel().serialize();
};
const validateChartType = (value) => {
    if (typeof value === "string" && value in ChartType) {
        return value;
    }
    return ChartType.classic;
};
const validateFilterPeriod = (value, fallbackValue) => {
    if (lodash_1.default.isArray(value)) {
        const numbersAndNulls = lodash_1.default.map(value, item => {
            const asNumber = lodash_1.default.toNumber(item);
            if (lodash_1.default.isFinite(asNumber)) {
                return asNumber;
            }
            return null;
        });
        const result = lodash_1.default.filter(numbersAndNulls, lodash_1.default.isNumber);
        if (!lodash_1.default.isEmpty(result)) {
            return result;
        }
    }
    return lodash_1.default.cloneDeep(fallbackValue);
};
const validateFilterCohortDays = (value) => {
    if (lodash_1.default.isPlainObject(value)) {
        const avgValue = lodash_1.default.get(value, HighchartsSettingsFilterCohortDays.avg);
        if (lodash_1.default.isBoolean(avgValue)) {
            const daysShiftValue = lodash_1.default.get(value, HighchartsSettingsFilterCohortDays.daysShift);
            if (lodash_1.default.isArray(daysShiftValue)) {
                return lodash_1.default.cloneDeep({
                    avg: avgValue,
                    daysShift: daysShiftValue,
                });
            }
        }
    }
    return lodash_1.default.cloneDeep(defaultFilterCohortDays);
};
exports.validateFilterCohortDays = validateFilterCohortDays;
